import { Outlet, createFileRoute } from '@tanstack/react-router'

import { AccentToggle, RadiusToggle, ThemeToggle } from '#/ui/ThemeToggle.js'
import { DesignLayout } from './-components/Sidebar.js'

export const Route = createFileRoute('/design')({
  component: DesignRoute,
})

function DesignRoute() {
  return (
    <DesignLayout>
      <div className="fixed top-4 right-4 z-50 flex items-center gap-2">
        <RadiusToggle />
        <AccentToggle />
        <ThemeToggle />
      </div>
      <Outlet />
    </DesignLayout>
  )
}
